import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, ChartDataLabels, Legend);

const data = {
    labels: ['Education Assistance', 'Medical Assistance', 'Clothing', 'Utilities', 'Food Support', 'Rental Assistance'],
    datasets: [
        {
            data: [10, 10, 10, 10, 20, 40],
            backgroundColor: [
                '#40ba7f',
                '#D079B7',
                '#5A96B1',
                '#ff5757',
                '#8964d3',
                '#febd59',
            ],
            hoverBackgroundColor: [
                '#40ba7f',
                '#D079B7',
                '#5A96B1',
                '#ff5757',
                '#8964d3',
                '#febd59',
            ],
            borderColor: [
                '#40ba7f',
                '#D079B7',
                '#5A96B1',
                '#ff5757',
                '#8964d3',
                '#febd59',               
            ],
            borderWidth: 2,
        },
    ],
};

const options = {
    responsive: true,
    maintainAspectRatio: false,
    padding: {
        top: 0 
      },
    plugins: {
        tooltip: {
            enabled: true,
        },
        legend: {
            display: true,
            position: 'left', 
            labels: {
                font: {
                    size: 14,
                },
                color: '#404040', 
            },
            reverse: true,
            onClick: null,
        },
        datalabels: {
            color: '#ffffff', 
            font: {
                size: 16,
                weight: 'bold',
            },
            formatter: (value) => `${value}%`, 
        },
    },
};


const ZakatChart = () => {
    return <Doughnut data={data} options={options} />;
};

export default ZakatChart;
